export const SEARCH_NAMES = {
  SORT_BY: "sortBy",
  SORT_ORDER: "sortOrder",
  SEARCH_TEXT: "searchText",
  CHANNEL_ID: "channelId",
  CHANNEL_TYPE: "channelType",
  PARENT_CHANNEL_ID: "parentChannelId",
  RESOURCE_TYPE: "resourceType",
  TAG_TITLE: "tagTitle",
  TAG_VALUE: "tagValue",
  CHARACTER_ID: "characterId",
  LETTER: "letter",
  SEARCH_TYPE: "searchType",
  SEARCH_ALSO_IN_OTHER_TOPICS: "searchAlsoInOtherTopics",
  SKIP: "skip",
  LIMIT: "limit",
  GROUP_SLUG: "groupSlug",
  U_TYPE: "uType",
  S_TYPE: "sType",
  INCLUDE_HM2: "includeHM2",
};

export const SEARCH_RANGES = {
  START: { value: "start", label: "od" },
  END: { value: "end", label: "do" },
  START_END: { value: "start_end", label: "od-do" },
  ALL: { value: "", label: "svi" },
};

export const SEARCH_SORT = {
  ASC: { value: 1, label: "rastuce" },
  DESC: { value: -1, label: "opadajuce" },
  SLUG: { value: "slug", label: "slug" },
  CONTENT: { value: "content", label: "content" },
};

export const SEARCH_NO_LIMIT = "SEARCH_NO_LIMIT";
